import { useMemo, useState, useContext } from "react";

//scss
import "./style.scss";

//components
import Faq from "./Faq";
import GreyInputBox from "./GreyInputBox";
import compareStrings from "helpers/compareString";
import AllFAQs from "./AllFAQs";
import { ListingInterface } from "context/ListingData";
import { AskMeModal } from "components/Booking/AskHelp";
import { useTheme } from "components/ListingNew/ListingTheme";

const Faqs = ({ faqData }) => {
	const faqs = useMemo(() => {
		return parseFaqs(faqData);
	}, [faqData]);

	const [faqSearch, setSearch] = useState("");

	//number of faqs being shown at home screen
	let faqCount = 0;

	//all faqs popup state
	const [open, setOpen] = useState(false);
	const [contactOpen, setContactOpen] = useState(false);

	const { calculations = {}, data } = useContext(ListingInterface);

	const listingList = data.data.listing_list;

	const theme = useTheme();
	return (
		<>
			{/* <ContactPopup open={contactOpen} setOpen={setContactOpen} /> */}
			<AskMeModal
				open={contactOpen}
				data={{
					theme: theme,
					LISTING_ID: listingList?.id,
					FROM_DATE:
						Object.keys(calculations).length > 0
							? calculations.FROM_DATE
							: "NA",
					TO_DATE:
						Object.keys(calculations).length > 0 ? calculations.TO_DATE : "NA",
					NO_OF_GUESTS:
						Object.keys(calculations).length > 0
							? calculations.NO_OF_GUESTS
							: listingList?.max_capacity,
					NO_OF_ROOMS:
						Object.keys(calculations).length > 0
							? calculations.NO_OF_ROOMS
							: listingList?.num_similar_rooms,
					TOTAL_AMOUNT_WITH_SERVICE:
						Object.keys(calculations).length > 0
							? calculations.TOTAL_AMOUNT_WITH_SERVICE
							: listingList?.per_night_charge,
					isListing: true,
				}}
				setOpen={setContactOpen}
			/>

			<section className="listing__faqs">
				<AllFAQs
					open={open}
					setOpen={setOpen}
					faqData={faqData}
					query={faqSearch}
					theme={theme}
					setQuery={setSearch}
				/>
				<GreyInputBox
					value={faqSearch}
					onChange={setSearch}
					className="listingFaqSearch"
					timeout={300}
					theme={theme}
				/>
				{faqs.map((faq, index) => {
					if (
						showFaq(
							faq.question_text + faq.question_answer,
							faqSearch,
							faqCount,
						)
					) {
						faqCount++;
						return <Faq {...faq} key={index} query={faqSearch} theme={theme} />;
					} else return null;
				})}
				{faqCount === 0 && faqSearch.length > 0 && (
					<i className="text-xsm-bold clr-grey">
						No results found <hr />
					</i>
				)}
			</section>

			<div className="faq-button">
				<span
					style={{
						...theme.borderBtn,
					}}
					className="listing__button__new__all"
					onClick={() => setOpen(true)}
				>
					See all FAQs
				</span>
			</div>
			<div
				className="contact-us-banner"
				style={
					theme?.background === "rgba(0, 0, 0, 1)"
						? {
								...theme?.borderBtn,
						  }
						: {}
				}
			>
				<div>
					<h2>Questions?</h2>
					<span
						style={
							theme?.background === "rgba(0, 0, 0, 1)"
								? {
										color: theme?.secondaryTextColor,
								  }
								: {}
						}
					>
						Our team is here to help you. Drop us a message!
					</span>
				</div>
				<div className="btn-wrapper">
					{/* <button id="all-faq-btn" onClick={() => setOpen(true)}>
						FAQs
					</button> */}
					<button
						style={
							theme?.background === "rgba(0, 0, 0, 1)"
								? {
										...theme?.borderBtn,
								  }
								: {}
						}
						onClick={() => setContactOpen(true)}
					>
						Contact us
					</button>
				</div>
			</div>
		</>
	);
};

export default Faqs;

const parseFaqs = (faqData) => {
	let faqs = [];
	Object.values(faqData).forEach((category) => {
		faqs.push(...category);
	});
	return faqs;
};

const showFaq = (string, query, faqCount) => {
	if ((compareStrings(string, query) || query === " ") && faqCount < 4)
		return true;
	return false;
};
